import { render, staticRenderFns } from "./coffee-card-controls.vue?vue&type=template&id=8517f53a&"
import script from "./coffee-card-controls.vue?vue&type=script&lang=js&"
export * from "./coffee-card-controls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports